import _classCallCheck from "/codebuild/output/src2922597434/src/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/codebuild/output/src2922597434/src/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/codebuild/output/src2922597434/src/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/codebuild/output/src2922597434/src/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/codebuild/output/src2922597434/src/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */
import * as React from 'react';
import { Context } from './injectIntl';
import { invariantIntlContext } from '../utils';
import { invariant } from '@formatjs/intl-utils';
var MINUTE = 60;
var HOUR = 60 * 60;
var DAY = 60 * 60 * 24;

function selectUnit(seconds) {
  var absValue = Math.abs(seconds);

  if (absValue < MINUTE) {
    return 'second';
  }

  if (absValue < HOUR) {
    return 'minute';
  }

  if (absValue < DAY) {
    return 'hour';
  }

  return 'day';
}

function getDurationInSeconds(unit) {
  switch (unit) {
    case 'second':
      return 1;

    case 'minute':
      return MINUTE;

    case 'hour':
      return HOUR;

    default:
      return DAY;
  }
}

function valueToSeconds(value, unit) {
  if (!value) {
    return 0;
  }

  switch (unit) {
    case 'second':
      return value;

    case 'minute':
      return value * MINUTE;

    default:
      return value * HOUR;
  }
}

var INCREMENTABLE_UNITS = ['second', 'minute', 'hour'];

function canIncrement() {
  var unit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'second';
  return INCREMENTABLE_UNITS.includes(unit);
}

export var FormattedRelativeTime = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(FormattedRelativeTime, _React$PureComponent);

  var _super = _createSuper(FormattedRelativeTime);

  function FormattedRelativeTime(props) {
    var _this;

    _classCallCheck(this, FormattedRelativeTime);

    _this = _super.call(this, props); // Public for testing

    _this._updateTimer = null;
    _this.state = {
      prevUnit: _this.props.unit,
      prevValue: _this.props.value,
      currentValueInSeconds: canIncrement(_this.props.unit) ? valueToSeconds(_this.props.value, _this.props.unit) : 0
    };
    invariant(!props.updateIntervalInSeconds || !!(props.updateIntervalInSeconds && canIncrement(props.unit)), 'Cannot schedule update with unit longer than hour');
    return _this;
  }

  _createClass(FormattedRelativeTime, [{
    key: "scheduleNextUpdate",
    value: function scheduleNextUpdate(_ref, _ref2) {
      var _this2 = this;

      var updateIntervalInSeconds = _ref.updateIntervalInSeconds,
          unit = _ref.unit;
      var currentValueInSeconds = _ref2.currentValueInSeconds;
      clearTimeout(this._updateTimer);
      this._updateTimer = null; // If there's no interval and we cannot increment this unit, do nothing

      if (!updateIntervalInSeconds || !canIncrement(unit)) {
        return;
      } // Figure out the next interesting time


      var nextValueInSeconds = currentValueInSeconds - updateIntervalInSeconds;
      var nextUnit = selectUnit(nextValueInSeconds); // We've reached the max auto incrementable unit, don't schedule another update

      if (nextUnit === 'day') {
        return;
      }

      var unitDuration = getDurationInSeconds(nextUnit);
      var remainder = nextValueInSeconds % unitDuration;
      var prevInterestingValueInSeconds = nextValueInSeconds - remainder;
      var nextInterestingValueInSeconds = prevInterestingValueInSeconds >= currentValueInSeconds ? prevInterestingValueInSeconds - unitDuration : prevInterestingValueInSeconds;
      var delayInSeconds = Math.abs(nextInterestingValueInSeconds - currentValueInSeconds);
      this._updateTimer = setTimeout(function () {
        return _this2.setState({
          currentValueInSeconds: nextInterestingValueInSeconds
        });
      }, delayInSeconds * 1e3);
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.scheduleNextUpdate(this.props, this.state);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.scheduleNextUpdate(this.props, this.state);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearTimeout(this._updateTimer);
      this._updateTimer = null;
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      return React.createElement(Context.Consumer, null, function (intl) {
        invariantIntlContext(intl);
        var formatRelativeTime = intl.formatRelativeTime,
            Text = intl.textComponent;
        var _this3$props = _this3.props,
            children = _this3$props.children,
            value = _this3$props.value,
            unit = _this3$props.unit,
            updateIntervalInSeconds = _this3$props.updateIntervalInSeconds;
        var currentValueInSeconds = _this3.state.currentValueInSeconds;
        var currentValue = value || 0;
        var currentUnit = unit;

        if (canIncrement(unit) && typeof currentValueInSeconds === 'number' && updateIntervalInSeconds) {
          currentUnit = selectUnit(currentValueInSeconds);
          var unitDuration = getDurationInSeconds(currentUnit);
          currentValue = Math.round(currentValueInSeconds / unitDuration);
        }

        var formattedRelativeTime = formatRelativeTime(currentValue, currentUnit, Object.assign({}, _this3.props));

        if (typeof children === 'function') {
          return children(formattedRelativeTime);
        }

        if (Text) {
          return React.createElement(Text, null, formattedRelativeTime);
        }

        return formattedRelativeTime;
      });
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      if (props.unit !== state.prevUnit || props.value !== state.prevValue) {
        return {
          prevValue: props.value,
          prevUnit: props.unit,
          currentValueInSeconds: canIncrement(props.unit) ? valueToSeconds(props.value, props.unit) : 0
        };
      }

      return null;
    }
  }]);

  return FormattedRelativeTime;
}(React.PureComponent);
FormattedRelativeTime.displayName = 'FormattedRelativeTime';
FormattedRelativeTime.defaultProps = {
  value: 0,
  unit: 'second'
};
export default FormattedRelativeTime;